import { DuplicateId, DuplicateIdProps } from "@mcleod/dispatch";
import { AutogenLayoutSalespersonReassignmentProfile } from "./autogen/AutogenLayoutSalespersonReassignmentProfile";
import { LookupModelSelectionEvent } from "@mcleod/components";
const viewSalespersonReassignmentProfileURL = "lme/crm/SalespersonReassignmentProfile?mode=update&key=";

const DUPLICATE_VALIDATION_PROPS: DuplicateIdProps = {
    tableName: "salesperson_reassign",
    screenName: "Salesperson Reassignment Profile",
    navigateToUrl: viewSalespersonReassignmentProfileURL
}
export class SalespersonReassignmentProfile extends AutogenLayoutSalespersonReassignmentProfile {
    onLoad(): void | Promise<void> {
        DuplicateId.configureIdTextbox(this.textboxId, DUPLICATE_VALIDATION_PROPS);
    }

    textboxSalespersonIdOnLookupModelSelection(event: LookupModelSelectionEvent) {
        if (event.hasSelection()) {
            this.mainDataSource.activeRow.set("email", event.selection.get("user_email"));
        }
    }
}